import { get, partialRight } from 'lodash-es';

export const selectInvoiceSendData = partialRight(get, 'invoice.invoiceSendData');
